import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PreviewLinkByPreviewIdQuery, PreviewLinkByPreviewIdQueryVariables } from './getPreviewLink.graphql';
import { PreviewLinkByPreviewId } from './getPreviewLink.graphql';

export type FilterKey = PreviewLinkByPreviewIdQueryVariables['filterKey'];
export type PreviewLinkResult = PreviewLinkByPreviewIdQuery['getPreviewLinks'];

export async function getPreviewLinkById(
	slug: string,
	{ gql: { fetch } }: UtilityContext,
	filterKey: FilterKey,
	filterValue: string | null,
): Promise<PreviewLinkResult> {
	const { data } = await fetch<PreviewLinkByPreviewIdQuery, PreviewLinkByPreviewIdQueryVariables>({
		query: PreviewLinkByPreviewId,
		variables: { slug, filterKey, filterValue },
		rejectOnError: true,
	});
	return data.getPreviewLinks;
}
